import { createSlice } from '@reduxjs/toolkit';

import { getProductPageStartAndEndIndex } from '../../utils/product';
import { loadPageOfProducts } from '../products/thunks/loadPageOfProducts';
import { updateFilters } from '../products/thunks/updateFilters';

export interface AccessibilityState {
  statusMessage: string;
}

export const initialState: AccessibilityState = {
  statusMessage: '',
};

export const { reducer, actions } = createSlice({
  name: 'accessibility',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadPageOfProducts.fulfilled, (state, { payload }) => {
        if (payload.data) {
          const { currentPage, perPage, items } = payload.data;
          const { start, end } = getProductPageStartAndEndIndex(
            perPage,
            currentPage,
            items[String(currentPage)].length,
          );

          state.statusMessage = `Products ${start} to ${end} loaded`;
        }
      })
      .addCase(loadPageOfProducts.pending, (state) => {
        state.statusMessage = 'Loading more products';
      })
      .addCase(loadPageOfProducts.rejected, (state) => {
        state.statusMessage = 'There was a problem loading more products';
      })
      .addCase(updateFilters.fulfilled, (state) => {
        state.statusMessage = `Products loaded`;
      })
      .addCase(updateFilters.pending, (state) => {
        state.statusMessage = 'Loading products';
      })
      .addCase(updateFilters.rejected, (state) => {
        state.statusMessage = 'There was a problem loading products';
      });
  },
});
